export const ENTITY = {
  //ENTITYS
  ENTITY_LogAcessos: 'TL_ACESSO',
  ENTITY_LogAcoes: 'TL_ACAO',

  ////HOME
  ENTITY_Glossario: 'TB_GLOSSARIO',

  ////GESTAO SISDAF
  ENTITY_Tickets: 'TB_TICKET',
  ENTITY_DocumentosSisAF: 'TB_DOCUMENTOS_SISAF',
  ENTITY_InformesSisAF: 'TB_INFORMES_SISAF',
  ENTITY_Tasks: 'TB_TASKS_SISAF',
  ENTITY_NotaVersaoSisAF: 'TB_NOTA_VERSAO_SISAF',
  ENTITY_Alerta: 'TB_ALERTA',

  ////PRODUTOS DAF
  ENTITY_DenominacaoGenerica: 'TB_DENOMINACAO_GENERICA',
  ENTITY_KitProduto: 'TB_KIT_PRODUTO',
  ENTITY_KitProdutoMany: 'RL_KIT_PRODUTO_DAF_MANY',
  ENTITY_ProdutoDAF: 'TB_PRODUTO_DAF',
  ENTITY_IncorpSUS: 'TB_INCORPORACAO_SUS',
  ENTITY_IncorpSUSCid: 'RL_INCORPORACAO_SUS_CID',
  ENTITY_ProdutoDAFTag: 'TB_TAG_PRODUTO',

  ////SES
  ENTITY_Ses: 'TB_SES',
  ENTITY_SesRt: 'RL_SES_RT',
  ENTITY_SesUsuario: 'TB_SES_USUARIO',
  ENTITY_VinculoSesUsuario: 'RL_VINCULO_SES_USUARIO',

  ////FORNECEDORES
  ENTITY_Faq: 'TB_FAQ',
  ENTITY_Fornecedor: 'TB_FORNECEDORES',
  ENTITY_FornecedorComunicacao: 'TB_FORNECEDORES_COMUNICACOES',
  ENTITY_FornecedorRepresentante: 'TB_FORNECEDORES_REPRESENTANTES',

  ////PROAQ
  ENTITY_Proaq: 'TB_PROAQ',
  ENTITY_Proaq_Destaque: 'TB_PROAQ_DESTAQUE',
  ENTITY_Proaq_Fase: 'TB_PROAQ_FASE',
  ENTITY_Proaq_Item: 'TB_PROAQ_ITEM',
  ENTITY_Proaq_Responsavel: 'TB_PROAQ_RESPONSAVEL',

  ////FLUXO PROAQ
  ENTITY_Fluxo_Proaq: 'TB_FLUXO_PROAQ',
  ENTITY_Fluxo_Proaq_Fase: 'TB_FLUXO_PROAQ_FASE',

  ////ALOCACAO DAF
  ENTITY_AlocacaoDAF: 'TB_ALOCACAO_DAF',

  ////Papel
  ENTITY_Papel: 'TB_PAPEL',

  ////Permissao
  ENTITY_Permissao: 'TB_USUARIO_PERMISSAO ',

  //CONTRATOS
  ENTITY_Arp: 'TB_ARP',
  ENTITY_Arp_Item: 'TB_ARP_ITEM',
  ENTITY_Contrato: 'TB_CONTRATO',
  ENTITY_Contrato_Objeto: 'TB_CONTRATO_OBJETO',
  ENTITY_Contrato_Parcela: 'TB_CONTRATO_PARCELA',
  ENTITY_Contrato_Entrega: 'TB_CONTRATO_ENTREGA',
  ENTITY_Empenho: 'TB_EMPENHO_ORC',
  ENTITY_Empenho_Item: 'TB_EMPENHO_ORC_ITEM',

  ////RELATORIO
  ENTITY_Relatorios: 'TB_RELATORIOS',

  ////TAGS
  ENTITY_TagsSisAF: 'TagsSisAF',

  ////ACTs
  ENTITY_ACT: 'TB_ACT',
  ////TAGS
  ENTITY_Org_Inter: 'TB_ORG_INTER',
  //TEDs
  ENTITY_Ted: 'TB_TED',
  ////AQUISICOES
  ENTITY_Tramitacao_Sei: 'TB_TRAMITACAO_SEI',
  ////LOTES FORNECEDORES
  ENTITY_Planta_Industrial: 'TB_PLANTA_INDUSTRIAL',
  ENTITY_OrdProd_Resp_Tecnico: 'TB_ORDPROD_RESP_TECNICO',
  ENTITY_Ordem_Producao: 'TB_ORD_PRODUCAO',
  ENTITY_Lote: 'TB_ORDEM_PRODUCAO_LOTE',

  ////MedSUSs
  ENTITY_Medsus_Item: 'TB_MEDSUS_ITEM',
  ENTITY_Medsus_Diretriz: 'TB_MEDSUS_DIRETRIZ',
  ENTITY_Medsus_Criterio: 'TB_MEDSUS_CRITERIO',
  ENTITY_Medsus_Documento: 'TB_MEDSUS_DOCUMENTO',
  ENTITY_Medsus_Cid: 'TB_MEDSUS_CID',
};
